module.exports = __webpack_public_path__ + "fonts/NotoSansMonoCJKkr-Regular.0fec43a7.otf";